<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <table-tool-bar>
                <template slot="left">
                    <table-searcher :disabled="loading"
                        v-model="filter.actName"
                        placeholder="请输入活动名称"
                        style="margin-left: 10px;"
                        @search="search"></table-searcher>
                </template>
                <Button v-if="$can('add')"
                    :class="preCls + 'button-margin'"
                    :disabled="loading"
                    type="primary"
                    @click="onClickAdd">新增活动</Button>
            </table-tool-bar>
            <Table ref="mt"
                :columns="columns"
                :data="page.list"
                :loading="loading"
                :height="mtHeight">
                <template v-slot:action="{ row }">
                    <Button v-if="$can('update') && row.actStatus == 0"
                        :disabled="loading"
                        type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickPublish(row)">发布</Button>
                    <Button v-if="$can('update') && row.actStatus == 2"
                        :disabled="loading"
                        type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickPublish(row)">取消发布</Button>
                    <Button :disabled="loading"
                        type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="showInfo(row)">详情</Button>
                    <PoptipButton v-if="$can('delete') && row.actStatus == 0"
                        :disabled="loading"
                        text="删除"
                        transfer
                        type="default"
                        title="您确定删除这条记录吗？"
                        :ok="() => { rowConfirmDelete(row) }"></PoptipButton>
                </template>
            </Table>
            <!-- 底部分页 -->
            <table-pager :total.sync="page.total"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.pageNo"
                @change="fetch"></table-pager>
            <!-- 弹出层 -->
            <smart-modal v-model="showActForm"
                :title="actId? '活动详情' :'新增活动'"
                :width="800"
                :height="550"
                :maskClosable="false"
                :buttons.sync="actFormBtns"
                @close-by-confirm="search">
                <act-form v-if="showActForm"
                    :id="actId"></act-form>
            </smart-modal>
        </div>
    </div>
</template>
<script>
import { SmartModal } from 'ivux'
import { mapCell, pipeCell } from '_c/grid/renderCell'
import ActForm from './form'
import { actList, actDelete, publish } from '@/api/act-info'
import Dict from '@/utils/dict'
import Enum from '@/utils/enum'
const actStatus = Enum.get('actStatus')
const fetchData = function() {
    return Dict.get(['property_type'])
}
const PAGE_SIZE = 20
export default {
    name: 'ListAct',
    components: {
        SmartModal,
        ActForm
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                actName: ''
            },
            page: {
                total: 0,
                list: []
            },
            dict: {
                property_type: Dict.NULL
            },
            showActForm: false,
            actFormBtns: [],
            actId: '',
            actStatus
        }
    },

    computed: {
        columns() {
            return [{
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'actName',
                    title: '活动名称',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true
                },
                {
                    key: 'actStatus',
                    title: '状态',
                    align: 'center',
                    minWidth: 150,
                    render: mapCell(this.statusList)
                },
                {
                    title: '开始时间',
                    key: 'startTime',
                    minWidth: 150,
                    render: pipeCell('ymdL')
                },
                {
                    title: '结束时间',
                    key: 'endTime',
                    minWidth: 150,
                    render: pipeCell('ymdL')
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    slot: 'action',
                    minWidth: 200
                }
            ]
        },
        statusList: function() {
            return this.actStatus.toList()
        }
    },
    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true

            Promise.all([actList(this.filter)])
                .then(args => {
                    var [page] = args
                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        fillData(dictGroup) {
            Object.keys(this.dict).forEach(name => {
                this.dict[name] = dictGroup[name] || Dict.NULL
            })
        },
        search() {
            this.page.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },

        onClickAdd(e) {
            this.actId = ''
            this.showActForm = true
        },

        showInfo(row) {
            this.actId = row.id
            this.showActForm = true
        },

        rowClickPublish(row) {
            this.loading = true
            publish(row.id)
                .then(res => {
                    this.$Message.success(this.$t('tips.update.success'))
                })
                .finally(() => this.fetch())
        },

        rowConfirmDelete(row) {
            this.loading = true
            actDelete(row.id)
                .then(el => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .finally(() => this.fetch())
        }
    },
    beforeRouteEnter(to, from, next) {
        fetchData().then(args => {
            next(vm => vm.fillData(args))
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>